import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MapState {
  zoom: number;
  center: {
    lat: number;
    lng: number;
  } | null;
}

const initialState: MapState = {
  zoom: 3,
  center: null,
};

const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setMapZoom: (state, action: PayloadAction<number>) => {
      state.zoom = action.payload;
    },
    setMapCenter: (state, action: PayloadAction<{ lat: number; lng: number }>) => {
      state.center = action.payload;
    },
    resetMap: (state) => {
      state.zoom = 3;
      state.center = null;
    },
  },
});

export const { setMapZoom, setMapCenter, resetMap } = mapSlice.actions;
export default mapSlice.reducer;
